
import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import {  getAllProducts } from "../features/products/productSlice";
import { Link, useParams,useNavigate,useLocation  } from "react-router-dom";
  import { useMediaQuery } from "react-responsive";
  import { brandByModel } from "../utils/brandsData";
  import ReactPaginate from "react-paginate";
  import { IoFilter } from "react-icons/io5";
  import { MdKeyboardBackspace } from "react-icons/md";
import ProductCard from "../components/ProductCard";
  import noResults from "../images/no_result.gif";
 import { RiGridFill } from "react-icons/ri";
 

const Usage= () => {
    const [grid, setGrid] = useState(4);
  const productState = useSelector(state => state?.product?.product)
  
  const [categories, setCategories] = useState([])
   const location = useLocation();
   const [showFilter, setShowFilter] = useState(false); 
 

  // Filter States
  const [tag, setTag] = useState(null)
  const [category, setCategory] = useState(null)
  const [brand, setBrand] = useState(null)
  const [minPrice,setMinPrice]=useState(null)
  const [maxPrice, setMaxPrice] = useState(null)
  const [sort,setSort]=useState(null)
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const productsState = useSelector(state => state?.product?.product)
   const [vehicleBrand, setVehicleBrand] = useState("");
   const [brandModel, setBrandModel] = useState("");
   const [minYear, setMinYear] = useState("");
   const [maxYear, setMaxYear] = useState("");
   
   const [selectedBudget, setSelectedBudget] = useState(null);
    const searchQuery = new URLSearchParams(location.search).get("search");
   const [selectedEngineSize, setSelectedEngineSize] = useState(null);
 
   const navigate=useNavigate();
const [popularProduct, setPopularProduct] = useState([]);

const { usage: usageFromUrl } = useParams();

const formatUsageName = (usage) => {
  if (!usage) return '';  

  const fullyCapitalizedUsages = ['SUV', 'MPV', 'EV'];

  return usage
    .split('-')
    .map(word => {
      const upperWord = word.toUpperCase();  
      if (fullyCapitalizedUsages.includes(upperWord)) {
        return upperWord;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

const formattedUsage = formatUsageName(usageFromUrl);

useEffect(() => {
  let data = [];
  for (let index = 0; index < productsState.length; index++) {
    const element = productsState[index];
    if (element.usage === formattedUsage) {  
      data.push(element);
    }
  }
  setPopularProduct(data);
}, [productsState, formattedUsage]);


useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const engineSize = queryParams.get("engine_size");  
  
    if (engineSize) {
      setSelectedEngineSize(engineSize);  
    }
  
   
  }, [location.search]);
 
 
  const dispatch = useDispatch();

  
  useEffect(() => {
    getProducts();
  }, [sort, tag, brand,   minPrice, maxPrice]);

  const getProducts = () => {
    dispatch(getAllProducts({ sort, tag, brand,  minPrice, maxPrice }));
  };

  

  const handleBackButtonClick = () => {
    setShowFilter(false);
    document.body.style.overflow = "auto";  
  };


  const toggleFilter = () => {
    setShowFilter(prev => {
      const newShowFilter = !prev;
      document.body.style.overflow = newShowFilter ? "hidden" : "auto";
      return newShowFilter;
    });
  };

  
   const handleSearch = () => {
   
     document.body.style.overflow = "auto"
   }
 
 
   const renderFilter = () => {
       return (
         <div className="shop-by-media">
       
                   <div className="filter-back-btn-wrapper">
             <Link 
               className="filter-btn-container1"
               onClick={handleBackButtonClick}>
               <MdKeyboardBackspace className="filter-back-icon" />
               <h2>Filter</h2>
             </Link>
           </div>
         <form onSubmit={handleSubmit} className="media-filter  filter-main-wrapper">
         <div className="filter-card-el">
           <h3 className="filter-title">Brand & Model</h3>
           <div className="d-flex flex-column align-items-center gap-10">
             {/* Brand Dropdown */}
             <div className="form-floating w-100">
               <select
                 className="form-select"
                 value={vehicleBrand}
                 onChange={handleBrandChange}
                
               >
                 <option value="">Select Brand</option>
                 {Object.keys(brandByModel).map((brand) => (
                   <option key={brand} value={brand}>
                     {brand}
                   </option>
                 ))}
               </select>
               <label htmlFor="floatingSelect">Brand</label>
             </div>
       
             {/* Model Dropdown */}
             <div className="form-floating w-100">
               <select
                 className="form-select"
                 value={brandModel}
                 onChange={(e) => setBrandModel(e.target.value)}
                 disabled={!vehicleBrand} 
               >
                 <option value="">Select Model</option>
                 {brandByModel[vehicleBrand]?.map((model, index) => (
                   <option key={index} value={model}>
                     {model}
                   </option>
                 ))}
               </select>
               <label htmlFor="floatingSelect">Model</label>
             </div>
           </div>
         </div>
       
         <div className="filter-card-el">
           <h3 className="filter-title">Year of Manufacture</h3>
           <div className="d-flex align-items-center gap-10">
             <div className="form-floating">
               <input
                 type="text"
                 className="form-control"
                 placeholder="Min YOM"
                 value={minYear}
                 onChange={(e) => setMinYear(e.target.value)}
               />
               <label htmlFor="floatingInput">Min YOM</label>
             </div>
             <div className="form-floating">
               <input
                 type="text"
                 className="form-control"
                 placeholder="Max YOM"
                 
                 value={maxYear}
                 onChange={(e) => setMaxYear(e.target.value)}
               />
               <label htmlFor="floatingInput1">Max YOM</label>
             </div>
           </div>
         </div>
   
         <div className="filter-card-el">
     <h3 className="filter-title">Filter by Engine Size</h3>
     <div className="engine-size-container   ">
       <ul className="mt-3">
         {engineSizes.map((size, index) => (
           <li key={index}>
           <button 
             className={`btn ${selectedEngineSize?.trim().toLowerCase() === size.trim().toLowerCase() ? "selected-size" : " "}`}
             onClick={() => handleEngineSizeFilter(size)}
           >
             {size}
           </button>
   
   
           </li>
         ))}
       </ul>
     </div>
   </div>
       
         {/* Filter by Budget */}
         <div className="filter-card-el mb-3">
           <h3 className="filter-title">Filter by Budget</h3>
           <ul className="budget-filter-element">
             <li
               className={selectedBudget?.[0] === 0 && selectedBudget?.[1] === 500000 ? 'selected' : ''}
               onClick={() => handleBudgetFilter(0, 500000)}
             >
               0-500K
             </li>
             <li
               className={selectedBudget?.[0] === 500000 && selectedBudget?.[1] === 1000000 ? 'selected' : ''}
               onClick={() => handleBudgetFilter(500000, 1000000)}
             >
               500K-1M
             </li>
             <li
               className={selectedBudget?.[0] === 1000000 && selectedBudget?.[1] === 2000000 ? 'selected' : ''}
               onClick={() => handleBudgetFilter(1000000, 2000000)}
             >
               1M-2M
             </li>
             <li
               className={selectedBudget?.[0] === 2000000 && selectedBudget?.[1] === 3000000 ? 'selected' : ''}
               onClick={() => handleBudgetFilter(2000000, 3000000)}
             >
               2M-3M
             </li>
             <li
               className={selectedBudget?.[0] === 3000000 && selectedBudget?.[1] === 5000000 ? 'selected' : ''}
               onClick={() => handleBudgetFilter(3000000, 5000000)}
             >
               3M-5M
             </li>
             <li
               className={selectedBudget?.[0] === 5000000 && selectedBudget?.[1] === 10000000 ? 'selected' : ''}
               onClick={() => handleBudgetFilter(5000000, 10000000)}
             >
               5M-10M
             </li>
             <li
               className={selectedBudget?.[0] === 10000000 && selectedBudget?.[1] === Infinity ? 'selected' : ''}
               onClick={() => handleBudgetFilter(10000000, Infinity)}
             >
               Above 10M
             </li>
             {selectedBudget && (
               <button type="button" className="clear-btn" onClick={clearBudgetFilter}>
                 Clear
               </button>
             )}
           </ul>
         </div>
       
         <button type="submit" className="btn" onClick={handleSearch}>Search</button>
       </form>
         </div>
   
                
       );
    };
   

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 14;


  const pageCount = Math.ceil(popularProduct.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;

  const handlePageChange = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };

  const currentProducts = popularProduct.slice(offset, offset + itemsPerPage);


  const handleSubmit = (e) => {
    e.preventDefault();
  
    const params = {
      search: searchQuery && searchQuery !== "null" ? searchQuery : undefined,
      vehicle_brand: vehicleBrand,
      brand_model: brandModel || undefined,
      year_of_manufacture__gte: minYear || undefined,
      year_of_manufacture__lte: maxYear || undefined,
      min_price: selectedBudget ? selectedBudget[0] : undefined,
      max_price: selectedBudget ? selectedBudget[1] : undefined,
      engine_size: selectedEngineSize || undefined, 
      sort: sort || undefined,
    };
  
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== "")
    );
  
    navigate(`/search?${new URLSearchParams(filteredParams).toString()}`, { replace: true });
  };
  
  const engineSizes = Array.from(
    new Set(productState?.map(item => item.engineSize?.title).filter(Boolean))  
  );
  
   
  const handleEngineSizeFilter = (size) => {
   setSelectedEngineSize(size);
    document.body.style.overflow = "auto"
  };

  
  const handleBrandChange = (e) => {
    setVehicleBrand(e.target.value);
    setBrandModel("");  
  };

  const handleBudgetFilter = (min, max) => {
    setSelectedBudget([min, max]);
    setMinPrice(min);
    setMaxPrice(max);
};


  const clearBudgetFilter = () => {
    setSelectedBudget(null);
 
  };



  return (
    <>
      <Meta 
        title={` ${formattedUsage}`}
        description={`Looking for the best ${formattedUsage} prices in Kenya? Browse top deals on new and used ${formattedUsage} cars. Find affordable, high-quality vehicles today!`}
        keywords={`${formattedUsage} cars in Kenya, best ${formattedUsage} prices in Kenya, buy ${formattedUsage} Kenya, affordable ${formattedUsage} cars, new and used ${formattedUsage} Kenya, latest ${formattedUsage} models Kenya`}
      />


    
      <BreadCrumb title={formattedUsage}/>
      <Container class1="search-wrapper home-wrapper-2 py-5">
        <div className="row vehicle-row">
          
        <form onSubmit={handleSubmit} className= {`col-3 filter-main-wrapper ${isDesktop ? "d-flex" : "d-none"}`}>
        <div className="filter-card-el">
     <h3 className="filter-title">Brand & Model</h3>
     <div className="d-flex flex-column align-items-center gap-10">
       {/* Brand Dropdown */}
       <div className="form-floating w-100">
         <select
           className="form-select"
           value={vehicleBrand}
           onChange={handleBrandChange}
          
         >
           <option value="">Select Brand</option>
           {Object.keys(brandByModel).map((brand) => (
             <option key={brand} value={brand}>
               {brand}
             </option>
           ))}
         </select>
         <label htmlFor="floatingSelect">Brand</label>
       </div>
 
       {/* Model Dropdown */}
       <div className="form-floating w-100">
         <select
           className="form-select"
           value={brandModel}
           onChange={(e) => setBrandModel(e.target.value)}
           disabled={!vehicleBrand}  
         >
           <option value="">Select Model</option>
           {brandByModel[vehicleBrand]?.map((model, index) => (
             <option key={index} value={model}>
               {model}
             </option>
           ))}
         </select>
         <label htmlFor="floatingSelect">Model</label>
       </div>
     </div>
   </div>
 
   <div className="filter-card-el">
     <h3 className="filter-title">Year of Manufacture</h3>
     <div className="d-flex align-items-center gap-10">
       <div className="form-floating">
         <input
           type="text"
           className="form-control"
           placeholder="Min YOM"
           value={minYear}
           onChange={(e) => setMinYear(e.target.value)}
         />
         <label htmlFor="floatingInput">Min YOM</label>
       </div>
       <div className="form-floating">
         <input
           type="text"
           className="form-control"
           placeholder="Max YOM"
           
           value={maxYear}
           onChange={(e) => setMaxYear(e.target.value)}
         />
         <label htmlFor="floatingInput1">Max YOM</label>
       </div>
     </div>
   </div>

   <div className="filter-card-el">
  <h3 className="filter-title">Filter by Engine Size</h3>
  <div className="engine-size-container   ">
    <ul className="mt-3">
      {engineSizes.map((size, index) => (
        <li key={index}>
        <button 
          className={`btn  ${selectedEngineSize  === size  ? "selected-size" : " "}`}
          onClick={() => handleEngineSizeFilter(size)}
        >
          {size}
        </button>


        </li>
      ))}
    </ul>
  </div>
</div>

 
   {/* Filter by Budget */}
   <div className="filter-card-el mb-3">
     <h3 className="filter-title">Filter by Budget</h3>
     <ul className="budget-filter-element">
       <li
         className={selectedBudget?.[0] === 0 && selectedBudget?.[1] === 500000 ? 'selected' : ''}
         onClick={() => handleBudgetFilter(0, 500000)}
       >
         0-500K
       </li>
       <li
         className={selectedBudget?.[0] === 500000 && selectedBudget?.[1] === 1000000 ? 'selected' : ''}
         onClick={() => handleBudgetFilter(500000, 1000000)}
       >
         500K-1M
       </li>
       <li
         className={selectedBudget?.[0] === 1000000 && selectedBudget?.[1] === 2000000 ? 'selected' : ''}
         onClick={() => handleBudgetFilter(1000000, 2000000)}
       >
         1M-2M
       </li>
       <li
         className={selectedBudget?.[0] === 2000000 && selectedBudget?.[1] === 3000000 ? 'selected' : ''}
         onClick={() => handleBudgetFilter(2000000, 3000000)}
       >
         2M-3M
       </li>
       <li
         className={selectedBudget?.[0] === 3000000 && selectedBudget?.[1] === 5000000 ? 'selected' : ''}
         onClick={() => handleBudgetFilter(3000000, 5000000)}
       >
         3M-5M
       </li>
       <li
         className={selectedBudget?.[0] === 5000000 && selectedBudget?.[1] === 10000000 ? 'selected' : ''}
         onClick={() => handleBudgetFilter(5000000, 10000000)}
       >
         5M-10M
       </li>
       <li
         className={selectedBudget?.[0] === 10000000 && selectedBudget?.[1] === Infinity ? 'selected' : ''}
         onClick={() => handleBudgetFilter(10000000, Infinity)}
       >
         Above 10M
       </li>
       {selectedBudget && (
         <button type="button" className="clear-btn" onClick={clearBudgetFilter}>
           Clear
         </button>
       )}
     </ul>
   </div>
 
   <button type="submit" className="btn">Search</button>
 </form>  
          
          <div className="col-9 search-container  position-relative">
            <div className="filter-sort-grid filter-container mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-10">
                  <p className="mb-0 d-block" style={{ width: "100px" }}>
                    Sort By:
                  </p>
                  <select
                    name=""
                    defaultValue={"manula"}
                    className="form-control form-select"
                    id=""
                    onChange={(e)=>setSort(e.target.value)}
                  >
                  
                    <option value="price">Price, low to high</option>
                    <option value="-price">Price, high to low</option>
                    </select>
                </div>
                <div className="d-flex products-count align-items-center gap-10">
                <p className="totalproducts mb-0">{currentProducts.length} Vehicles</p>
                  <div className="d-flex gap-10 align-items-center grid">
                 <RiGridFill className="grid-icon"/>
 

  

       
                  </div>
                </div>

                                 {!isDesktop && (
                                  <div className="filter-wrapper">
                                   <button onClick={toggleFilter}>
                                   <IoFilter className="filter-icon"/>
                                      </button>
                                     </div>
                                     )}
                                           
              </div>
            </div>
            <div className="products-list   ">
                        {currentProducts.length === 0 ? (
                 <div className="no-results">
                   <img src={noResults} alt="no results gif"/>
                  </div>
               ) : (
         <>
            {isDesktop ? (

            <>
            <div className="grid-section grid-three">
              {currentProducts.slice(0, 6).map((product, index) => (
                <ProductCard key={index} data={product} grid={grid} />
              ))}
            </div>

            </>):(
         <div className="search-list ">
         {currentProducts.map((product, index) => (
           <ProductCard key={index} data={product}  />
         ))}
       </div>
)}
</>
)}

            </div>


          </div>
        </div>
        <div className="grid-section grid-four">
              {currentProducts.slice(6, 14).map((product, index) => (
                <ProductCard key={index + 6} data={product} grid={grid} />
              ))}
            </div>

            
        <div className="d-flex  paginate-container1 mt-3">
     <div>
        <ReactPaginate
        breakLabel="..."
        nextLabel=" >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={3}
         marginPagesDisplayed={1}   
        pageCount={pageCount}
        previousLabel="< "
        renderOnZeroPageCount={null}
        containerClassName="pagination1"
        pageLinkClassName="page-num"
        previousLinkClassName="page-num"
        nextLinkClassName="page-num"
        activeLinkClassName="active"
        forcePage={currentPage}
      />
      </div>
        </div>

        {showFilter && renderFilter()} 

      </Container>
    </>
  );
};

export default Usage;
